import { isLocalDev } from "./environments";

const ALLOWED_SEARCH_PARAMS = [
  "entity_host",
];

export function getFullUrl(url: string, isExternal: boolean) {
  const fullUrl = new URL(url, window.location.href);
  if (!isExternal && isLocalDev) {
    new URLSearchParams(window.location.search).forEach((v, k) => {
      if (ALLOWED_SEARCH_PARAMS.includes(k)) {
        fullUrl.searchParams.set(k, v);
      }
    });
  }
  return fullUrl;
}